/*
 * Broadcast Theme – Custom JS
 * Switch header + dropdown colours based on scroll
 * Dark when over hero image, light once scrolled past it.
 */

(function () {
  const HERO_SELECTOR = '.media.media--cover'; // hero image container

  function updateHeaderMode() {
    const body = document.body;
    const hero = document.querySelector(HERO_SELECTOR);

    // If no hero (e.g. other pages), just use light mode
    if (!hero) {
      body.classList.add('header-light-bg');
      body.classList.remove('header-dark-bg');
      return;
    }

    const heroRect = hero.getBoundingClientRect();
    const HEADER_HEIGHT = 80; // approx header height in px

    // If the bottom of the hero is still below the header,
    // the header is visually over the dark image.
    const headerOverHero = heroRect.bottom - HEADER_HEIGHT > 0;

    if (headerOverHero) {
      body.classList.add('header-dark-bg');
      body.classList.remove('header-light-bg');
    } else {
      body.classList.add('header-light-bg');
      body.classList.remove('header-dark-bg');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateHeaderMode();
    window.addEventListener('scroll', updateHeaderMode);
    window.addEventListener('resize', updateHeaderMode);
  });
})();
